import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../types/actionParams';
import { IViewActions } from '../types/IViewActions';

export class GetViewActionsRequest extends Request<ISingleIdParams, IViewActions> {
  constructor(id: string) {
    super('getViewActions', { id: id });
  }
}
